import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { LegacyResponseApplicationError } from '@verantos-dev/types-common';

import { ApiCreateWorkflowDialogContentProps } from './ApiWorkflowDialogContent';

export const useApiWorkflowDialogContent = ({
  dialogMessages,
  initialLoadingError,
  submittingError,
}: ApiCreateWorkflowDialogContentProps) => {
  const {
    loadingErrorText,
    loadingErrorTitle,
    loadingTitle,
    submittingErrorTitle: submittingErrorTitleOverride,
    submittingErrorText: submittingErrorTextOverride,
    successText,
    successTitle,
  } = dialogMessages || {};

  const initialLoadingErrorTitle = loadingErrorTitle || getTitleFromError(initialLoadingError);
  const initialLoadingErrorText = loadingErrorText || getTextFromError(initialLoadingError);
  const submittingErrorTitle = submittingErrorTitleOverride || getTitleFromError(submittingError);
  const submittingErrorText = submittingErrorTextOverride || getTextFromError(submittingError);

  return {
    initialLoadingTitle: loadingTitle || 'Loading',
    initialLoadingErrorTitle,
    initialLoadingErrorText: initialLoadingErrorText,
    submittingErrorTitle,
    submittingErrorText,
    submittedTitle: successTitle || 'Success',
    submittedText: successText || 'The operation was successful',
  };
};

const getTitleFromError = (
  error: LegacyResponseApplicationError[] | FetchBaseQueryError | SerializedError | undefined,
  defaultErrorTitle = 'Error'
) => {
  if (error && 'name' in error) {
    return error.name || defaultErrorTitle;
  }

  return defaultErrorTitle;
};

const getTextFromError = (
  error: LegacyResponseApplicationError[] | FetchBaseQueryError | SerializedError | undefined,
  defaultErrorText = 'An unknown error occurred'
) => {
  if (error && 'message' in error) {
    return error.message;
  }
  if (error && 'error' in error) {
    return error.error;
  }

  return defaultErrorText;
};
